import type { MiddlewareFunction } from 'react-router';

import { getRouteFromWindow, routerState } from '@trello/router';
import { navigationState } from '@trello/router/router-link';

/**
 * Update the {@link routerState} when react-router navigates to a new route.
 */
export const routerStateMiddleware: MiddlewareFunction = async (
  _args,
  next,
): Promise<void> => {
  navigationState.setValue({
    isNavigating: true,
  });
  try {
    await next();
    routerState.setValue(getRouteFromWindow());
  } finally {
    navigationState.setValue({
      isNavigating: false,
    });
  }
};
